var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-switch",class:{ active: _vm.value },on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon-bl"},[(_vm.value)?_c('i',{staticClass:"el-icon-moon"}):_c('i',{staticClass:"el-icon-sunny"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }